import Vue from 'vue'
import Router from 'vue-router'
import Main from './views/Main.vue'
import Home from './views/Home.vue'
import About from './components/about/About.vue'
import Proposal from './components/index/Proposal.vue'

// import ScheduleIn from './components/schedule/ScheduleIn.vue'
import ScheduleIn from './components/schedule/ScheduleInV1.vue'

import news_center from './components/news/news_center.vue'
import News_list from './components/news/News_list.vue'
import news_page from './components/news/news_page.vue'
import winner_center from './components/winner/winner_center.vue'
import winner_list from './components/winner/winner_list.vue'
import winner_page from './components/winner/winner_page.vue'
import documentary_center from './components/documentary/documentary_center.vue'
import documentary_list from './components/documentary/documentary_list.vue'
import documentary_page from './components/documentary/documentary_page.vue'
import Gift_center from './components/Gift/Gift_center.vue'
import FreeTicket_center from './components/FreeTicket/FreeTicket_center.vue'
import ContactUs from './components/ContactUs/ContactUs.vue'

import top from './components/partner/top.vue'
import toplink from './components/partner/toplink.vue'
import partner from './components/partner/partner.vue'

import policy from './components/privacy/policy.vue'
import tou from './components/privacy/tou.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main,
      children: [
        {path: '', name: 'home', component: Home},
        {path: 'about', name: 'about', component: About},
        {path: 'schedule', name: 'schedule', component: ScheduleIn},
        {path: 'schedule/:category_id', name: 'scheduleIn', component: ScheduleIn,},
        {path: 'news', name: 'news_center', component: news_center,children: [
          {path: '', name: 'news', component: News_list},
          {path: ':id', name: 'news_page', component: news_page}
        ]},
        {path: 'winner', name: 'winner_center', component: winner_center,children: [
          {path: '', name: 'winner_list', component: winner_list},
          {path: ':id', name: 'winner_page', component: winner_page}
        ]},
        {path: 'documentary', name: 'documentary_center', component: documentary_center,children: [
          {path: '', name: 'documentary_list', component: documentary_list},
          {path: ':id', name: 'documentary_page', component: documentary_page}
        ]},
        {path: 'gift', name: 'Gift_center', component: Gift_center},
        {path: 'freeticket', name: 'FreeTicket_center', component: FreeTicket_center},
        {path: 'contact', name: 'contact_us', component: ContactUs},

        {path: 'top', name: 'top', component: top},
        {path: 'toplink', name: 'toplink', component: toplink},
        {path: 'partner', name: 'partner', component: partner},
        {path: 'policy', name: 'policy', component: policy},
        {path: 'tou', name: 'tou', component: tou},
        {path: 'proposal/:id', name: 'Proposal', component: Proposal},
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
